import useLocationEvents from "./hooks/use-location-events";

// must be a component that lives inside the Router, so must be a child component of <LiveEvent /> to get the location updates
// rather than just a hook used in live-event.tsx
export default function LocationTracking({ debug }: { debug?: boolean }) {
	useLocationEvents(debug);

	return null;
}